var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = window.money_format;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

const new_defaults = {
    cartModal: '.js-ajax-cart-modal', // classname
    cartModalContent: '.js-ajax-cart-modal-content', // classname
    cartModalClose: '.js-ajax-cart-modal-close', // classname
    cartDrawer: '.js-ajax-cart-drawer', // classname
    cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
    cartDrawerClose: '.js-ajax-cart-drawer-close', // classname
    cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
    cartOverlay: '.js-ajax-cart-overlay', // classname
    cartCounter: '.js-ajax-cart-counter', // classname
    addToCart: '.js-ajax-add-to-cart', // classname
    removeFromCart: '.js-ajax-remove-from-cart', //classname
    removeFromCartNoDot: 'js-ajax-remove-from-cart', //classname,
    checkoutButton: '.js-ajax-checkout-button',
};

const cartModal = document.querySelector(new_defaults.cartModal);
const cartModalContent = document.querySelector(new_defaults.cartModalContent);
const cartModalClose = document.querySelector(new_defaults.cartModalClose);
const cartDrawer = document.querySelector(new_defaults.cartDrawer);
const cartDrawerContent = document.querySelector(new_defaults.cartDrawerContent);
const cartDrawerClose = document.querySelector(new_defaults.cartDrawerClose);
const cartDrawerTrigger = document.querySelector(new_defaults.cartDrawerTrigger);
const cartOverlay = document.querySelector(new_defaults.cartOverlay);
const cartCounter = document.querySelector(new_defaults.cartCounter);
const addToCart = document.querySelectorAll(new_defaults.addToCart);
let removeFromCart = document.querySelectorAll(new_defaults.removeFromCart);
const checkoutButton = document.querySelector(new_defaults.checkoutButton);
const htmlSelector = document.documentElement;

var $ = jQuery;

for (let i = 0; i < addToCart.length; i++) {

    addToCart[i].addEventListener('click', function(event) {

        event.preventDefault();
        const formID = $(this).closest('form').attr('id');
        console.log(formID);

        addProductToCart(formID);
		return false;
    });

}

function addProductToCart(formID) {

    const quantity = $('.product__holder-inner #' + formID).find('input[name="quantity"]').val();
    $.ajax({
      type: "post",
      url: "/cart/add.js",
      data: $('.product__holder-inner #' + formID).serialize(),
      dataType: "json",
      success: function(data){
        addToCartOk();

        // dispatch event
        var event = new CustomEvent('addToCart', {
          detail: {
            cart: data,
            quantity: quantity
          }
        });

        document.dispatchEvent(event);
      },
      error: function(err){
        addToCartFail(formID);
      }
    })
}

function fetchCart() {
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
            onCartUpdate(cart);

            if (cart.item_count === 0) {
                cartDrawerContent.innerHTML = "<div class='empty_text'>Your shopping cart is empty.<br></div>";
                $('.psh-Cart_Footer,.psh-Topbar_Subtitle').hide();
              $('.js-ajax-cart-counter').text(cart.item_count);
              $('.js-ajax-cart-drawer-content').append($('.ctm_empty_cpy_txt').clone());
              $('.js-ajax-cart-drawer-content .ctm_empty_cpy_txt').removeClass('hide');
              $('.drw-Drawer').addClass('js-empty_drawer');
            } else {
                renderCart(cart);
              $('.js-ajax-cart-counter').text(cart.item_count);
               $('.js-ajax-cart-drawer-content .ctm_empty_cpy_txt').remove();
              $(checkoutButton).removeClass('is-hidden');
              $('.psh-Cart_Footer,.psh-Topbar_Subtitle').show();
              $('.drw-Drawer').removeClass('js-empty_drawer');
            }

        },
    });
}

function changeItem(line, data, callback) {
    const quantity = 0;
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                onCartUpdate(cart);
                fetchCart();
                removeProductFromCart();
            }

            // dispatch event
            var event = new CustomEvent('removeFromCart', {
              detail: {
                cart: data
              }
            });

            document.dispatchEvent(event);
        },
    });
}



function addToCartOk(product) {
//     cartModalContent.innerHTML = product.title + ' was added to the cart!';
//     cartCounter.innerHTML = Number(cartCounter.innerHTML) + 1;
//     openAddModal();
//     openCartOverlay();
  fetchCart();
  $('.nav .btn-cart.js-cart-toggle')[0].click()
}

function removeProductFromCart() {
    $(cartCounter).html(Number($(cartCounter).html()) - 1);
}

function addToCartFail(form_id) {

//     cartModalContent.innerHTML = 'The product you are trying to add is out of stock.';
   $('.ctm_product_added_err').removeClass('ctm_product_added_err');
	$('#'+form_id).closest('.product-card').find('.product-card__info').append('<p class="ctm_product_added_err">The product you are trying to add is out of stock.</p>');
    setTimeout(function(e){
	  $('.ctm_product_added_err').remove();
    },4000)
//     openAddModal();
//     openCartOverlay();
}


function renderCart(cart) {

    console.log(cart);

    clearCartDrawer();


    cart.items.forEach(function(item, index) {

      //console.log(item.title);
      //console.log(item.image);
      //console.log(item.line_price);
      //console.log(item.quantity);

      var origin = "//cdn.shopify.com/";
      var small_img_extension = item.image.split(origin)[1];
      var small_img_url = origin + small_img_extension.split('.')[0] + '_100x.' + small_img_extension.split('.')[1];

      const productTitle = ' <h5 class="psh-Item_Title "><a class="psh-Item_TitleLink" href="'+ item.url +'">' + item.title + '</a></h5>';
      const productImage = '<a class="psh-Item_ImageContainer" href="'+ item.url +'"><img class="psh-Item_Image" src="' + small_img_url + '" ></a>';
      var prod_variant =''
      if(item.options_with_values[0].value != 'Default Title'){
       prod_variant = '<div class="ctm_selected_variant">'+item.options_with_values[0].name+': <span>'+item.options_with_values[0].value+'</span></div>'
       }

      var properties_personlis = '';
      var total_extra_price = 0;
      if(item.properties['Add Leg O Muttons for £150 each'] != '' && item.properties['Add Leg O Muttons for £150 each'] != undefined){
        if(item.properties['Add Leg O Muttons for £150 each'].indexOf('[') > 0){
          var price = item.properties['Add Leg O Muttons for £150 each'].split('[')[1].split(']')[0];
          var count = 0;
          if(price.indexOf('$') > -1){
            price	= price.split('$')[1].split('USD')[0].trim();
            count++;
          }
          if(price.indexOf('€') > -1){
            price	= price.split('€')[1].split('GBP')[0].trim();
            count++;
          }
          if(price.indexOf('£') > -1){
            price	= price.split('£')[1].split('EUR')[0].trim();
            count++;
          }
          var new_html = '';
          if(count != 0){
            price = parseInt(price);
            new_html = '[+<span class="money">'+price+'</span>]';
            console.log(price,'price ..');
          }
          total_extra_price = price * 100;
          properties_personlis += '<div class="cart-property"><span class="property_name">Reduced Leg o Mutton:</span><span class="property_value">'+item.properties['Add Leg O Muttons for £150 each'].split('[')[0]+new_html+'</span></div>'
        }else{
          properties_personlis += '<div class="cart-property"><span class="property_name">Reduced Leg o Mutton:</span><span class="property_value">'+item.properties['Add Leg O Muttons for £150 each']+'</span></div>'
        }
      }

      if(item.properties['Add iPad Insert'] != '' && item.properties['Add iPad Insert'] != undefined){
        if(item.properties['Add iPad Insert'].indexOf('[') > 0){
          var price = item.properties['Add iPad Insert'].split('[')[1].split(']')[0];
          var count = 0;
          if(price.indexOf('$') > -1){
            price	= price.split('$')[1].split('USD')[0].trim();
            count++;
          }
          if(price.indexOf('€') > -1){
            price	= price.split('€')[1].split('GBP')[0].trim();
            count++;
          }
          if(price.indexOf('£') > -1){
            price	= price.split('£')[1].split('EUR')[0].trim();
            count++;
          }
          var new_html = '';
          if(count != 0){
            price = parseInt(price);
            new_html = '[+<span class="money">'+price+'</span>]';
            console.log(price,'price ..');
          }

          total_extra_price = price * 100;
          properties_personlis += '<div class="cart-property"><span class="property_name">iPad Insert:</span><span class="property_value">'+item.properties['Add iPad Insert'].split('[')[0]+new_html+'</span></div>'
        }else{
          properties_personlis += '<div class="cart-property"><span class="property_name">iPad Insert:</span><span class="property_value">'+item.properties['Add iPad Insert']+'</span></div>'
        }
      }

      if(item.properties['Add Waterproof Lining'] != '' && item.properties['Add Waterproof Lining'] != undefined){
        if(item.properties['Add Waterproof Lining'].indexOf('[') > 0){
          var price = item.properties['Add Waterproof Lining'].split('[')[1].split(']')[0];
          var count = 0;
          if(price.indexOf('$') > -1){
            price	= price.split('$')[1].split('USD')[0].trim();
            count++;
          }
          if(price.indexOf('€') > -1){
            price	= price.split('€')[1].split('GBP')[0].trim();
            count++;
          }
          if(price.indexOf('£') > -1){
            price	= price.split('£')[1].split('EUR')[0].trim();
            count++;
          }
          var new_html = '';
          if(count != 0){
            price = parseInt(price);
            new_html = '[+<span class="money">'+price+'</span>]';
            console.log(price,'price ..');
          }

          total_extra_price = price * 100;
          properties_personlis += '<div class="cart-property"><span class="property_name">Waterproof Lining:</span><span class="property_value">'+item.properties['Add Waterproof Lining'].split('[')[0]+new_html+'</span></div>'
        }else{
          properties_personlis += '<div class="cart-property"><span class="property_name">Waterproof Lining:</span><span class="property_value">'+item.properties['Add Waterproof Lining']+'</span></div>'
        }
      }

      if(item.properties['Add Initials'] != '' && item.properties['Add Initials'] != undefined){
        if(item.properties['Add Initials'].indexOf('[') > 0){
          var price = item.properties['Add Initials'].split('[')[1].split(']')[0];
          var count = 0;
          if(price.indexOf('$') > -1){
            price	= price.split('$')[1].split('USD')[0].trim();
            count++;
          }
          if(price.indexOf('€') > -1){
            price	= price.split('€')[1].split('GBP')[0].trim();
            count++;
          }
          if(price.indexOf('£') > -1){
            price	= price.split('£')[1].split('EUR')[0].trim();
            count++;
          }
          var new_html = '';
          if(count != 0){
            price = parseInt(price);
            new_html = '[+<span class="money">'+price+'</span>]';
            console.log(price,'price ..');
          }

          total_extra_price = price * 100;
          properties_personlis += '<div class="cart-property"><span class="property_name">Add Initials:</span><span class="property_value">'+item.properties['Add Initials'].split('[')[0]+new_html+'</span></div>'
        }else{
          properties_personlis += '<div class="cart-property"><span class="property_name">Add Initials:</span><span class="property_value">'+item.properties['Add Initials']+'</span></div>'
        }
      }

      if(item.properties['Initials'] != '' && item.properties['Initials'] != undefined){
        if(item.properties['Initials'].indexOf('[') > 0){
          var price = item.properties['Initials'].split('[')[1].split(']')[0];
          var count = 0;
          if(price.indexOf('$') > -1){
            price	= price.split('$')[1].split('USD')[0].trim();
            count++;
          }
          if(price.indexOf('€') > -1){
            price	= price.split('€')[1].split('GBP')[0].trim();
            count++;
          }
          if(price.indexOf('£') > -1){
            price	= price.split('£')[1].split('EUR')[0].trim();
            count++;
          }
          var new_html = '';
          if(count != 0){
            price = parseInt(price);
            new_html = '[+<span class="money">'+price+'</span>]';
            console.log(price,'price ..');
          }

          total_extra_price = price * 100;
          properties_personlis += '<div class="cart-property"><span class="property_name">Initials:</span><span class="property_value">'+item.properties['Initials'].split('[')[0]+new_html+'</span></div>'
        }else{
          properties_personlis += '<div class="cart-property"><span class="property_name">Initials:</span><span class="property_value">'+item.properties['Initials']+'</span></div>'
        }

      }

	    total_extra_price = item.price;
      const item_html_data = `data-product-id="${item.product_id}" data-title="${item.title}" data-price="${item.price}" data-quantity="${item.quantity}"`;
      const productPrice = properties_personlis+' <p class="psh-Item_Price fz-1320"><span class="money">' + Shopify.formatMoney(total_extra_price, Shopify.money_format) + '</span></p>';
      var productQuantity = '<div class="psh-Item_Controls"  data-line="' + Number(index + 1) + '"><div class="psh-Quantity">';
      productQuantity +=   '<div class="product-quantity-box"><button class="psh-Quantity_Button psh-Quantity_Decrease product-minus js-change-quantity"  data-func="minus"><svg width="10" height="4" viewBox="0 0 10 4" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.837461 0.874V3.656H9.15746V0.874H0.837461Z" fill="#F4F3FF"/> </svg></button><input type="text" min="0" class="psh-Quantity_Value fz-1417 quantity" name="updates[]" id="updates_'+item.id+'" value="'+item.quantity+'" data-price="'+item.price+'" data-previous-quantity="'+item.quantity+'" data-cart-quantity-input="mini-cart"><button class="psh-Quantity_Button psh-Quantity_Increase product-plus js-change-quantity" data-func="plus"><svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.09 3.874H7.37201V0.156H4.59001V3.874H0.898008V6.656H4.59001V10.348H7.37201V6.656H11.09V3.874Z" fill="#F4F3FF"/> </svg></button></div></div>'
      productQuantity += '<div ' + item_html_data +' class="ajax-cart-item__remove ' + new_defaults.removeFromCartNoDot + '">Remove</div> </div>';
      var html = ' <li class="psh-Body_Item" data-cart-form="mini-cart" data-cart-item data-line-id="' + Number(index + 1) + '" data-variant-id="'+item.id+'"><div class="ajax-cart-item__single psh-Item">'
      const concatProductInfo = html + productImage + '<div class="psh-Item_Content">' +  productTitle
//       + prod_variant
      + productPrice + productQuantity + '</div></div>' ;
      cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo;
      cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + '</div></li>'
      console.log(Array.from(item.properties),item.properties['Add Personalisation'],item.properties.length)
    });

    removeFromCart = document.querySelectorAll(new_defaults.removeFromCart);
  console.log('demo',Shopify.formatMoney(cart.items_subtotal_price, Shopify.money_format))
//     $('.psh-Footer_Subtotal span').text(Shopify.formatMoney(cart.items_subtotal_price, Shopify.money_format));
    for (let i = 0; i < removeFromCart.length; i++) {
      removeFromCart[i].addEventListener('click', function() {
        const line = this.parentNode.getAttribute('data-line');
        const itemData = {
          product_id: this.getAttribute('data-product-id'),
          product_title: this.getAttribute('data-title'),
          price: this.getAttribute('data-price'),
          quantity: this.getAttribute('data-quantity'),
        }
        this.parentNode.getAttribute('data-variant-id');

        changeItem(line, itemData);
      });
    }



    // document.querySelectorAll('.js-ajax-remove-from-cart')
    //     .forEach((element) => {
    //         element.addEventListener('click', function() {
    //             const lineID = this.parentNode.getAttribute('data-line');
    //             console.log('aa');
    //         });
    //     });



}

function openCartDrawer() {
    cartDrawer.classList.add('is-open');
}

function closeCartDrawer() {
    cartDrawer.classList.remove('is-open');
}

function clearCartDrawer() {
    cartDrawerContent.innerHTML = '';
}
function onCartUpdate(cart) {
    console.log('items in the cart?', cart.item_count);

  var total_extra_price = 0;
  cart.items.forEach(function(item, index) {

    if(item.properties['Add Leg O Muttons for £150 each'] != '' && item.properties['Add Leg O Muttons for £150 each'] != undefined){
      if(item.properties['Add Leg O Muttons for £150 each'].indexOf('[') > 0){
        var price = item.properties['Add Leg O Muttons for £150 each'].split('[')[1].split(']')[0];
        var count = 0;
        if(price.indexOf('$') > -1){
          price	= price.split('$')[1].split('USD')[0].trim();
          count++;
        }
        if(price.indexOf('€') > -1){
          price	= price.split('€')[1].split('GBP')[0].trim();
          count++;
        }
        if(price.indexOf('£') > -1){
          price	= price.split('£')[1].split('EUR')[0].trim();
          count++;
        }
        var new_html = '';
        if(count != 0){
          price = parseInt(price);
        }
        total_extra_price = price * 100;
      }
    }

    if(item.properties['Add iPad Insert'] != '' && item.properties['Add iPad Insert'] != undefined){
      if(item.properties['Add iPad Insert'].indexOf('[') > 0){
        var price = item.properties['Add iPad Insert'].split('[')[1].split(']')[0];
        var count = 0;
        if(price.indexOf('$') > -1){
          price	= price.split('$')[1].split('USD')[0].trim();
          count++;
        }
        if(price.indexOf('€') > -1){
          price	= price.split('€')[1].split('GBP')[0].trim();
          count++;
        }
        if(price.indexOf('£') > -1){
          price	= price.split('£')[1].split('EUR')[0].trim();
          count++;
        }
        var new_html = '';
        if(count != 0){
          price = parseInt(price);
        }

        total_extra_price = price * 100;
      }
    }

    if(item.properties['Add Waterproof Lining'] != '' && item.properties['Add Waterproof Lining'] != undefined){
      if(item.properties['Add Waterproof Lining'].indexOf('[') > 0){
        var price = item.properties['Add Waterproof Lining'].split('[')[1].split(']')[0];
        var count = 0;
        if(price.indexOf('$') > -1){
          price	= price.split('$')[1].split('USD')[0].trim();
          count++;
        }
        if(price.indexOf('€') > -1){
          price	= price.split('€')[1].split('GBP')[0].trim();
          count++;
        }
        if(price.indexOf('£') > -1){
          price	= price.split('£')[1].split('EUR')[0].trim();
          count++;
        }
        var new_html = '';
        if(count != 0){
          price = parseInt(price);
        }
        total_extra_price = price * 100;
      }
    }


    if(item.properties['Add Initials'] != '' && item.properties['Add Initials'] != undefined){
      if(item.properties['Add Initials'].indexOf('[') > 0){
        var price = item.properties['Add Initials'].split('[')[1].split(']')[0];
        var count = 0;
        if(price.indexOf('$') > -1){
          price	= price.split('$')[1].split('USD')[0].trim();
          count++;
        }
        if(price.indexOf('€') > -1){
          price	= price.split('€')[1].split('GBP')[0].trim();
          count++;
        }
        if(price.indexOf('£') > -1){
          price	= price.split('£')[1].split('EUR')[0].trim();
          count++;
        }
        var new_html = '';
        if(count != 0){
          price = parseInt(price);
        }

        total_extra_price = price * 100;
      }
    }

    if(item.properties['Initials'] != '' && item.properties['Initials'] != undefined){
      if(item.properties['Initials'].indexOf('[') > 0){
        var price = item.properties['Initials'].split('[')[1].split(']')[0];
        var count = 0;
        if(price.indexOf('$') > -1){
          price	= price.split('$')[1].split('USD')[0].trim();
          count++;
        }
        if(price.indexOf('€') > -1){
          price	= price.split('€')[1].split('GBP')[0].trim();
          count++;
        }
        if(price.indexOf('£') > -1){
          price	= price.split('£')[1].split('EUR')[0].trim();
          count++;
        }
        var new_html = '';
        if(count != 0){
          price = parseInt(price);
        }

        total_extra_price = price * 100;
      }
    }

  })
  $('.js-cart-toggle > span > span').text(cart.item_count);
  setTimeout(function(){
    var cart_total = cart.items_subtotal_price + total_extra_price;
    $('.psh-Footer_Subtotal span').html(Shopify.formatMoney(cart_total, Shopify.money_format));
  },50)
}

// function openAddModal() {
//     cartModal.classList.add('is-open');
// }

// function closeAddModal() {
//     cartModal.classList.remove('is-open');
// }

// function openCartOverlay() {
//     cartOverlay.classList.add('is-open');
//     htmlSelector.classList.add('is-locked');
// }

// function closeCartOverlay() {
//     cartOverlay.classList.remove('is-open');
//     htmlSelector.classList.remove('is-locked');
// }

// cartModalClose.addEventListener('click', function() {
//     closeAddModal();
// //     closeCartOverlay();
// });

// cartDrawerClose.addEventListener('click', function() {
//     closeCartDrawer();
// //     closeCartOverlay();
// });
// cart is empty stanje
// cartOverlay.addEventListener('click', function() {
// //     closeAddModal();
//     closeCartDrawer();
// //     closeCartOverlay();
// });

// cartDrawerTrigger.addEventListener('click', function(event) {
//     event.preventDefault();
//     //fetchCart();
//     openCartDrawer();
// //     openCartOverlay();
// });

document.addEventListener('DOMContentLoaded', function() {
    fetchCart();
});


$('body').on('change', '[data-cart-quantity-input]', function() {
  var cartItem = {
    lineID: $(this).parents('[data-cart-item]').data('line-id'),
    variantID: $(this).parents('[data-cart-item]').data('variant-id'),
    quantity: $(this).val(),
    price : $(this).data('price'),
    quantityPrevious: $(this).data('previous-quantity'),
    parentCartForm: $(this).parents('[data-cart-form]'),
    totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
    $element : $(this).parents('[data-cart-item]'),
    $title: $(this).parents('[data-cart-item]').find('.psh-Item_TitleLink').text()
  }
  // Disable button after click to prevent multiple clicks
  $(this).parents('.product-quantity-box').find('.js-change-quantity').addClass('is-disabled');
  updateCartItemQuantity(cartItem);

  // update previous quantity
  $(this).data('previous-quantity', $(this).val());
});

$('body').on('click', '.js-change-quantity', function() {
  var $this = $(this),
      $input = $(this).siblings('input'),
      val = parseInt($input.val()),
      valMax = 100000000000000000000000000000,
      valMin = $input.attr('min') || 0;

  if ($input.attr('max') != null){
    valMax = $input.attr('max');
  }

  if(isNaN(val) || val < valMin) {
    $input.val(valMin);
    return false;
  } else if (val > valMax) {
    $input.val(valMax);
    return false;
  }

  if($this.data('func') == 'plus') {
    if(val < valMax) $input.val(val + 1);
  } else {
    if(val > valMin) $input.val(val - 1);
    if($this.parents(".cart_item").length) {
      if (val - 1 == 0) {
        $this.closest('.cart_item').addClass('animated fadeOutUp')
      }
    }
  }
  $input.trigger('change');

});

function checkDataLayerEvent(cartItem) {
  const currentQuantity = parseInt(cartItem.quantity);
  const previousQuantity = parseInt(cartItem.quantityPrevious);
  const quantityDifference = currentQuantity - previousQuantity;

  // check if this is a remove or add event
  if (quantityDifference > 0) {
    const data = {
      product_id: `${cartItem.variantID}`,
      product_title: cartItem.$title,
      price: cartItem.price,
      quantity: quantityDifference
    }
    // dispatch event
    var event = new CustomEvent('addToCart', {
      detail: {
        cart: data
      }
    });

    document.dispatchEvent(event);
  } else if (quantityDifference < 0) {
    const data = {
      product_id: `${cartItem.variantID}`,
      product_title: cartItem.$title,
      price: cartItem.price,
      quantity: previousQuantity - currentQuantity
    }
    // dispatch event
    var event = new CustomEvent('removeFromCart', {
      detail: {
        cart: data
      }
    });

    document.dispatchEvent(event);
  }
}


function updateCartItemQuantity(cartItem) {

  $.ajax({
    url: '/cart/change.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: {
      quantity: cartItem.quantity,
      line: cartItem.lineID
    },
    success: function (data) {
      console.log(data)
      console.log(cartItem.quantity,cartItem.lineID);

      checkDataLayerEvent(cartItem);


      var cartItemsArray = data.items;
      var lineIDIndex = cartItem.lineID - 1;
      var totalCartItems = cartItem.parentCartForm.find('[data-variant-id]').length;
      var $quantityInputs = cartItem.parentCartForm.find('[data-variant-id="' + cartItem.variantID + '"] input');
      var initialQuantityTotal = 0;
      var apiQuantityTotal = 0;
      var apiLineItemQuantity = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;

      // Check if item has a "Buy X get Y" deal
      if ($quantityInputs.length > 1) {
        // Multiple inputs

        // Get all the quantities of same variants in the cart (including BOGO) in HTML
        $.each($quantityInputs, function (i, input) {
          initialQuantityTotal += parseInt($(input).val());
        });

        // Get quantities from cart object returned from API
        cartItemsArray.forEach(function (item) {
          if (item.variant_id === cartItem.variantID) {
            apiQuantityTotal += item.quantity;
          }
        })
      } else {
        // Single input
        initialQuantityTotal = parseInt($quantityInputs.val());
        apiQuantityTotal = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;
      }

      //Checks to see if there is enough inventory to update to an increased amount
      if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {

        //Check if Buy one get one product
        if (totalCartItems < cartItemsArray.length) {
          fetchCart();
        }

      }else {

        fetchCart();
      }

    },
    error: function(err){
      console.log('test 123456')
    }
  });
}
$(window).on('load',function(e){
  $(".cart-slider").on('click',function(){
    $(".drw-Drawers, body").addClass("drw-Drawers-active");
    $(".drw-Drawer").addClass("drw-Drawer-active");
  });

  $(".psh-TopBar_Close, .drw-Drawers_Backdrop").on('click',function(){
    $(".drw-Drawers, body").removeClass("drw-Drawers-active");
    $(".drw-Drawer").removeClass("drw-Drawer-active");
  });
  $('.contine_btn').on('click',function(e){
    e.preventDefault();
    $('.psh-TopBar_Close').trigger('click');
    return false;
  })
})
